import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { useTranslation } from "gatsby-plugin-react-i18next"
import kuveyt1 from "../../assets/img/kuveyt1.png"
import kuveyt2 from "../../assets/img/kuveyt3.png"

export default function KuveytturkProjesi() {
  const { t } = useTranslation()
  return (
    <Layout>
      <SEO title="Kuveyt Türk Katılım Projesi" />
      <div className="projeler-container page">
        <div className="ic-proje">
          <img src={kuveyt1} alt="" className="proje-icGorsel" />
          <div className="proje-kunye">
            <span>{t("project-brand")}</span>: {t("kuveyt-turk")}
            <br />
            <span>{t("project-sector")}</span>: {t("finans")}
            <br />
            <span>{t("project-subject")}</span>: {t("logonun-yorumu")}
            <br />
            <span>{t("project-artwork")}</span>: {t("allah-cc-tekrari")}
          </div>
          <img src={kuveyt2} alt="" className="proje-icGorsel" />
        </div>
      </div>
    </Layout>
  )
}
